import React, { Component } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch,
    Hits,
    SearchBox,
    Configure,
    Pagination,
    connectStateResults
} from 'react-instantsearch-dom';
import { object, string, array, bool } from 'prop-types';
import Icon from 'components/icon';
import BlogTile from 'components/tiles/BlogTile';
import NewsStripTile from 'components/tiles/NewsStripTile';
import TaggedTile from 'components/tiles/TaggedTile';
import ContactLayout from 'components/filtered-listing/layouts/ContactLayout';
import DropdownFilter from './dropdown-filter/';
import CustomCurrentRefinements from './CustomCurrentRefinements/';

// eslint-disable-next-line react/prefer-stateless-function
class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mediaContact: {
                title: this.props.mediaContactTitle,
                name: this.props.mediaContactName,
                email: this.props.mediaContactEmail,
                number1: this.props.mediaContactPhone1,
                number2: this.props.mediaContactPhone2
            },
            showFilter: false,
            activeFilter: {}
        };

        this.toggleActiveFilter = this.toggleActiveFilter.bind(this);
    }

    toggleActiveFilter(filter, reset) {
        const activeFilter = { ...this.state.activeFilter };
        activeFilter[filter] = reset;
        this.setState({ activeFilter });
    }

    toggleFilter(e) {
        e.preventDefault();

        if (this.state.showFilter) {
            document.body.classList.remove('no-scroll');
        } else {
            document.body.classList.add('no-scroll');
        }

        this.setState({ showFilter: !this.state.showFilter });
    }

    render() {
        return (
            <div className={`filters-top grey-filter-bg type-${this.props.contentTypeName}`}>
                <InstantSearch
                    indexName={this.props.appIndex}
                    searchClient={algoliasearch(this.props.appId, this.props.appKey)}
                >
                    <Configure
                        filters={
                            `contentTypeName:${this.props.contentTypeName}${this.props.defaultFilter}`
                        }
                        hitsPerPage={10}
                    />
                    {this.props.contentTypeName === 'fc___external_resource_link' &&
                        <div className="mobile-trigger open-trigger">
                            <div className="container">
                                <a href="#toggle-filter" className="btn btn-skin-2 btn-icon-center" onClick={e => this.toggleFilter(e)}>
                                    <Icon glyph="filter" />
                                    <span>Filter by</span>
                                </a>
                            </div>
                        </div>
                    }

                    <div className={`filters-layout ${this.props.contentTypeName}-${this.state.showFilter}`}>
                        <div className="filters-section">
                            <div className="filters-container">
                                <div className="filters">
                                    {this.props.contentTypeName === 'fc___external_resource_link' &&
                                        <div className="mobile-trigger">
                                            <p className="display-micro">Filter by</p>
                                            <a href="#toggle-filter" className="close-icon" onClick={e => this.toggleFilter(e)}>
                                                <Icon glyph="cross" />
                                            </a>
                                        </div>
                                    }
                                    {this.props.contentFilters.map(value => (
                                        <DropdownFilter
                                            toggleActiveFilter={this.toggleActiveFilter}
                                            reset={this.state.activeFilter[value]}
                                            attribute={value}
                                            attributePlural={this.props.contentFiltersPlural ? this.props.contentFiltersPlural[value] : ''}
                                            attributePseudonym={this.props.contentFiltersPseudonym && this.props.contentFiltersPseudonym[value] ? this.props.contentFiltersPseudonym[value] : ''}
                                            key={value}
                                            disableShowAll={!this.props.loadInitialContent}
                                        />
                                    ))}
                                    {!this.props.noKeyword &&
                                        <div className="keyword-filter textbox-wrapper filter-item">
                                            <SearchBox />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    { this.state.mediaContact !== null &&
                        <ContactLayout
                            contact={this.state.mediaContact}
                        />
                    }

                    {this.props.contentTypeName === 'fc___external_resource_link' &&
                        <div className="container">
                            <div className={`active-filter ${this.props.contentTypeName}`}>
                                <CustomCurrentRefinements
                                    toggleActiveFilter={this.toggleActiveFilter}
                                    transformItems={items =>
                                        items.map(item => {
                                            return ({
                                                ...item,
                                                label: item.currentRefinement
                                            });
                                        })
                                    }
                                />
                            </div>
                        </div>
                    }
                    <div className="listing-items-section">
                        <div className="listing-items-container">
                            <Results loadInitialContent={this.props.loadInitialContent}>
                                <div className="listing-items-wrapper">
                                    <div className="listing-items">
                                        <div className={`algolia-listing-container ${this.props.contentTypeName}`}>

                                            <Hits
                                                hitComponent={Hit}
                                            />
                                        </div>
                                    </div>
                                    <div className="listing-pagination-section">
                                        <div className="listing-pagination">
                                            <nav className="c-pagination-simple">
                                                <Pagination showFirst={false} />
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </Results>
                        </div>
                    </div>
                </InstantSearch>
            </div>
        );
    }
}

const Results = connectStateResults(({ searchState, children, props }) =>
    (((props.loadInitialContent ||
        (searchState && ((searchState.menu && Object.values(searchState.menu).filter(value => value !== '').length > 0) ||
        (searchState.query && searchState.query.length > 0))))
    ) ? (
            children
        ) : (
            <div />
        )));
function Hit(props) {
    switch (props.hit.contentTypeName) {
        case 'fc___external_resource_link':
            return (
                <TaggedTile item={props.hit} featured={false} algolia={true} />
            );
        case 'page___blog_article':
            return (
                <BlogTile item={props.hit} featured={false} algolia={true} />
            );
        default:
            return (
                <NewsStripTile item={props.hit} featured={false} algolia={true} />
            );
    }
}

/* eslint-disable react/no-typos */
/* eslint-disable react/forbid-prop-types */
Hit.propTypes = { hit: object.isRequired };

App.propTypes = {
    appIndex: string.isRequired,
    appId: string.isRequired,
    appKey: string.isRequired,
    contentTypeName: string.isRequired,
    contentFilters: array.isRequired,
    contentFiltersPlural: object.isRequired,
    noKeyword: bool,
    mediaContactName: string,
    mediaContactPhone1: string,
    mediaContactPhone2: string,
    mediaContactEmail: string,
    mediaContactTitle: string,
    defaultFilter: string,
    contentFiltersPseudonym: object,
    loadInitialContent: bool
};
App.defaultProps = {
    noKeyword: false,
    mediaContactTitle: '',
    mediaContactName: '',
    mediaContactPhone1: '',
    mediaContactPhone2: '',
    mediaContactEmail: '',
    defaultFilter: '',
    contentFiltersPseudonym: {},
    loadInitialContent: true
};

export default App;



// WEBPACK FOOTER //
// ./src/sections/algolia-filter/index.jsx